<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66667 10.0003H16.3333M16.3333 10.0003L10.5 4.16699M16.3333 10.0003L10.5 15.8337"
      stroke="currentColor"
      stroke-width="1.67"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
